// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"UpdateOrderItem_cancelButton__CB0ag","attributesContainer":"UpdateOrderItem_attributesContainer__gWt5K"};